<template>
  <div>
    <v-app-bar app outlined color="secondary" dark>
      <p class="ma-0">Mamnon</p>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="white" dark v-bind="attrs" v-on="on">
            <v-icon>mdi-translate</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item link to="/privacy/ar">
            <v-list-item-title >العربية</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/privacy/en">
            <v-list-item-title>English</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
export default {};
</script>
